<template>
  <Teleport to="body">
    <div
      class="modalBg modalHeight w-full flex items-center justify-center mobOnly:px-12"
      @click.self="close"
    >
      <div
        class="bg-lightest w-full max-w-556 p-16 desk:p-32 max-h-[80vh] overflow-y-auto shadow-xl relative"
      >
        <div class="type-headline-md leading-single mb-12">
          {{ $t('checkout.createPayer.headline') }}
        </div>
        <p class="type-sm mb-16">{{ $t('checkout.createPayer.description') }}</p>

        <form @submit.prevent="handleSubmit">
          <div class="mb-12">
            <input
              id="firstName"
              v-model="firstName"
              type="text"
              required
              class="w-full px-16 py-12 border border-border-base bg-bg-base type-sm"
              :placeholder="$t('form.placeholder.firstName')"
            >
          </div>

          <div class="mb-24">
            <input
              id="lastName"
              v-model="lastName"
              type="text"
              required
              class="w-full px-16 py-12 border border-border-base bg-bg-base type-sm"
              :placeholder="$t('form.placeholder.lastName')"
            >
          </div>

          <div class="flex flex-row flex-wrap items-center justify-end gap-y-8 gap-x-16">
            <button
              type="button"
              class="btn btn--text"
              @click="close"
            >
              {{ $t('modal.generic.abort') }}
            </button>
            <button
              type="submit"
              class="btn"
              :disabled="loading"
              :class="{
                'loading': loading
              }"
            >
              {{ $t('checkout.createPayer.save') }}
            </button>
          </div>
        </form>

        <button
          class="absolute top-8 right-8 desk:top-24 desk:right-24 p-8 text-icon-subtle hover:text-icon-base transition-all"
          type="button"
          @click="close"
        >
          <GlobalIcon name="close" size="small" />
        </button>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { useCartStore } from '~/store/cart';
import { useUiStore } from '~/store/ui';

const { $t } = useNuxtApp();
const cartStore = useCartStore();
const uiStore = useUiStore();

const firstName = ref('');
const lastName = ref('');
const loading = ref(false);

const emit = defineEmits<{
  (e: 'created'): void;
  (e: 'close'): void;
}>();

const handleSubmit = async() => {
  if (!firstName.value.trim() || !lastName.value.trim()) {
    return;
  }

  loading.value = true;
  const success = await cartStore.createAndSetPayer(firstName.value.trim(), lastName.value.trim());
  loading.value = false;

  if (success) {
    // Reset form
    firstName.value = '';
    lastName.value = '';

    // Emit created event so CheckoutTypeSelector can refresh
    emit('created');

    // Close the modal
    close();
  }
};

const close = () => {
  uiStore.setShowCreatePayerModal(false);
  emit('close');
};
</script>
